import { useGantnerDevices, useOpenGantnerDevice } from 'api/GantnerDevices'
import { Modal, ModalProps } from 'ui/Modal'
import { PaginatedMiniList } from './PaginatedMiniList'
import { ResourceListItem } from './ResourceListItem'
import { canRemotelyOpenDevice } from 'components/SettingsDirectory/Site/Integrations/Gantner'
import { Notification, useNotificationContext } from './Notification'
import { useCurrentSiteId } from 'contexts/SiteConfig'
import { FC } from 'react'

type Props = Pick<ModalProps, 'isOpen' | 'onClose'>

export const OpenGantnerDeviceModal: FC<Props> = ({ isOpen, onClose }) => {
  const notifications = useNotificationContext()
  const siteId = useCurrentSiteId()
  const { isLoading, isError, data } = useGantnerDevices()
  const { isLoading: isOpening, mutate: openGantnerDevice } = useOpenGantnerDevice()

  const supportedDevices = data?.data.filter(canRemotelyOpenDevice)

  const handleOpenDevice = (device) => {
    openGantnerDevice([siteId, device.id], {
      onSuccess: () => {
        notifications.notify(
          <Notification
            title="Success"
            description={`Successfully opened Gantner device ${device.name}`}
            variant="success"
            autoDismiss
          />
        )

        onClose(false)
      },
      onError: (e: any) => {
        notifications.notifyApiError(e)
      },
    })
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Open Gantner device">
      <PaginatedMiniList
        isLoading={isLoading}
        isError={isError}
        emptyMessage="No supported Gantner devices found"
        rows={supportedDevices?.map((device) => (
          <ResourceListItem
            key={device.id}
            title={device.name}
            onClick={() => handleOpenDevice(device)}
            disabled={isOpening}
          />
        ))}
      />
    </Modal>
  )
}
